<template lang="pug">
.bar-grafico
    div(
        v-if='tabAtiva === "1" || tabAtiva === "2" || culturaSelecionada === "SOJA"'
    )
        ApexCharts.component.apexcharts-canvas(
            type='bar',
            height='450',
            ref='chartInteligenciaTerritorial',
            :options='chartOptions',
            :series='dados'
        )
        span.apexcharts-xaxis-title-custom
            | {{ textoLegenda }}
    AvisoCulturaNaoSelecionada(
        v-else-if='tabAtiva === "3" || culturaSelecionada !== "SOJA"',
        :show='true',
        :tabAtiva='tabAtiva',
        :culturaSelecionada='culturaSelecionada'
    )
</template>

<script>
import _ from 'lodash';
import ApexCharts from 'vue-apexcharts';
import AvisoCulturaNaoSelecionada from './AvisoCulturaNaoSelecionada.vue';
import EventBus from '@/utils/eventBus';

export default {
    name: 'GraficoBarrasInteligenciaTerritorial',
    components: {
        ApexCharts,
        AvisoCulturaNaoSelecionada
    },
    props: {
        dados: {
            type: Array,
            default: () => []
        },
        categorias: {
            type: Array,
            default: () => []
        },
        coresBarras: {
            type: Array,
            default: () => ['#740F0F', '#AD6A01', '#4F7200']
        },
        corUnica: {
            type: Boolean,
            default: true
        },
        textoLegenda: {
            type: String,
            default: ''
        },
        textoTooltip: {
            type: String,
            default: ' milhões ha'
        },
        culturaSelecionada: {
            type: String,
            default: ''
        },
        tabAtiva: {
            type: String,
            default: ''
        },
        isLoadingRanking: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {};
    },
    computed: {
        chartOptions: {
            get() {
                const textoTooltip_ = this.textoTooltip;
                const textoLegenda = this.textoLegenda;
                const dados_ = this.dados[0].data.length;
                const categorias_ = this.categorias;
                const corUnica_ = this.corUnica;
                const coresBarras_ = this.coresBarras;
                const isLoadingRanking_ = this.isLoadingRanking;

                return {
                    chart: {
                        type: 'bar',
                        height: 450,
                        stacked: !corUnica_,
                        fontFamily: 'Roboto, sans-serif',
                        toolbar: {
                            show: false
                        },
                        events: {
                            click: (event, chartContext, config) => {
                                let conteudoLinhaGrafico =
                                    config.config.xaxis.categories[
                                        config.dataPointIndex
                                    ];
                                let indexCategoria = config.dataPointIndex;
                                if (conteudoLinhaGrafico) {
                                    EventBus.$emit(
                                        'inteligenciaTerritorial:atualizar-filtros-click-grafico',
                                        conteudoLinhaGrafico,
                                        indexCategoria
                                    );
                                }
                            }
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                            borderRadius: 7,
                            barHeight: '90%',
                            dataLabels: {
                                total: {
                                    enabled: false
                                }
                            }
                        }
                    },
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 800,
                        animateGradually: {
                            enabled: true,
                            delay: 150
                        },
                        dynamicAnimation: {
                            enabled: true,
                            speed: 350
                        }
                    },
                    noData: {
                        text: isLoadingRanking_
                            ? 'Carregando informações...'
                            : 'Não há dados a serem mostrados.',
                        align: 'center',
                        verticalAlign: 'middle',
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            color: undefined,
                            fontSize: '14px',
                            fontFamily: undefined
                        }
                    },
                    grid: {
                        show: true,
                        position: 'back',
                        xaxis: {
                            lines: {
                                show: true
                            }
                        },
                        yaxis: {
                            lines: {
                                show: false
                            }
                        },
                        row: {
                            colors: undefined,
                            opacity: 0.5
                        },
                        column: {
                            colors: undefined,
                            opacity: 0.5
                        },
                        padding: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    colors: corUnica_ ? ['#00413C'] : coresBarras_,
                    stroke: {
                        width: 1,
                        colors: ['#fff']
                    },
                    title: {
                        text: ''
                    },
                    xaxis: {
                        categories: categorias_,
                        tickAmount: 8,
                        position: 'bottom',
                        title: {
                            text: undefined,
                            style: {
                                color: '#3B3B3B',
                                fontSize: '14px',
                                fontFamily: 'Roboto, sans-serif',
                                fontWeight: 700
                            }
                        },
                        min: 0,
                        max: this.maxLabelNumber,
                        labels: {
                            style: {
                                color: '#3B3B3B',
                                fontSize: this.mudaTamanhoFonte,
                                fontFamily: 'Roboto, sans-serif',
                                fontWeight: 500
                            },
                            formatter(val) {
                                if (textoLegenda !== 'Produção (ton)' && textoLegenda !== 'Área (ha)') {
                                    val /= 1000;
                                    if (textoLegenda === 'Produção (milhões ton)' && val >= 100) {
                                        val /= 1000;
                                    } else if (val >= 1000 && textoLegenda !== 'Área (milhares ha)') {
                                        val /= 1000;
                                        if (val >= 100) {
                                            val /= 1000;
                                        }
                                    }
                                }
                                return val.toLocaleString('pt-BR', { maximumFractionDigits: 1 });
                            }
                        }
                    },
                    yaxis: {
                        title: {
                            text: undefined
                        },
                        labels: {
                            show: dados_ > 0,
                            align: 'left',
                            minWidth: 50,
                            maxWidth: 140,
                            offsetX: -10,
                            style: {
                                color: '#3B3B3B',
                                fontSize: '14px',
                                fontFamily: 'Roboto, sans-serif',
                                fontWeight: 500
                            },
                            formatter(val, index) {
                                if (val && index) {
                                    return `${
                                        index.dataPointIndex + 1
                                    }º ${val}`;
                                }
                            }
                        }
                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                return (
                                    val.toLocaleString('pt-BR', {
                                        maximumFractionDigits: 0
                                    }) + textoTooltip_
                                );
                            }
                        }
                    },
                    fill: {
                        opacity: 1
                    },
                    legend: {
                        show: !corUnica_,
                        position: 'top',
                        offsetY: 20,
                        fontSize: '14px',
                        markers: {
                            width: 25,
                            height: 12
                        }
                    }
                };
            },
            set() {}
        },
        mudaTamanhoFonte() {
            if (this.textoLegenda === 'Produção (ton)' || this.textoLegenda === 'Área (ha)') {
                return '12px';
            } else {
                return '14px';
            }
        },
        maxLabelNumber() {
            if (this.corUnica && this.dados.length === 1) {
                let max = _.max(this.dados[0].data);
                let maxAux = 0;
                if (max >= 1 && max <= 10) {
                    maxAux = 2;
                } else if (max > 10 && max <= 20) {
                    maxAux = 5;
                } else if (max > 20 && max <= 100) {
                    maxAux = 10;
                } else if (max > 100 && max <= 500) {
                    maxAux = 50;
                } else if (max > 500 && max <= 1000) {
                    maxAux = 100;
                } else if (max > 1000) {
                    maxAux = 300;
                }
                return max + maxAux;
            } else if (this.dados.length > 1) {
                const maxNumberMultiLabelChart = [
                    _.max(this.dados[0].data),
                    _.max(this.dados[1].data),
                    _.max(this.dados[2].data)
                ];
                return _.sum(maxNumberMultiLabelChart) + 1;
            }
            return _.max(this.dados[0].data);
        }
    }
};
</script>
<style>
.apexcharts-xaxis-title-custom {
    font-size: 14px;
    font-weight: 700;
    color: #3b3b3b;
    position: absolute;
    bottom: 3%;
    right: 3%;
}
</style>
